import Cookies from './_virtual-es-cookie.js';
import { deserializeCF } from './src-serializer.js';

const CF_COOKIE_NAME = "userContext";
function isTreatmentEnabled(treatmentId) {
  try {
    return getAndParseCookie().includes(treatmentId);
  } catch (e) {
    console.warn("ctc-reader in isTreatmentEnabled failed.", e);
    return false;
  }
}
function getAllTreatments() {
  try {
    return getAndParseCookie();
  } catch (e) {
    console.warn("ctc-reader in getAllTreatments failed.", e);
    return [];
  }
}
var index = {
  isTreatmentEnabled,
  getAllTreatments
};
function getAndParseCookie() {
  const cfCookie = Cookies.get(CF_COOKIE_NAME);
  if (!cfCookie) {
    console.warn(
      "ctc-reader: Context cookie are missing. If you are developing locally check the readme;)"
    );
    return [];
  }
  return deserializeCF(cfCookie);
}

export { index as default, getAllTreatments, isTreatmentEnabled };
//# sourceMappingURL=ctc-reader.js.map
